
const selectors = {
    body: 'body',
    cart: 'js-cart',
    checkoutBtn: 'js-checkout-btn'
};
/*
 * Show Product Level Error Message
 */
function showProductLevelErrorMessage(data) {
    data.items.forEach(element => {
        if (!element.available) {
            let uuid = element.UUID;

            $(selectors.body)
                .trigger('basket:update:availability', { data, uuid });

            const $spinButton = $(`.js-line-item-qty[data-uuid="${uuid}"]`);

            $spinButton.addClass('js-not-update-availability');

            if ($spinButton[0].spinbutton) {
                $spinButton[0].spinbutton.valuenow = element.availability.ats;
            }
        }
    });
}

function getErrorMessage(data) {
    let errorMessage = '';

    data.items.forEach(element => {
        if (!element.available) {
            errorMessage = element.availability.valid.messages;
        }
    });

    return errorMessage;
}
/*
 * CallBack for clouse modal
 */
function closeModalCallBack(data) {
    let message = getErrorMessage(data);
    if (message) {
        data.valid.message = message;
    }
    data.isShowButton = true;

    $(selectors.body).trigger('basket:validate', data);
}

/*
 * Open Modal Dialog
 */
function openModalDialog(data) {
    const modalDialogContent = $('#validate-cart-content-template').html(),
        $body = $(selectors.body);

    $body.append(modalDialogContent);
    window.dialogManager.openDialog('modal', '#updatedQuantityCartModal', $('.' + selectors.checkoutBtn)[0]);

    $('#updatedQuantityCartModal')[0].addEventListener('dialog:closed', () => {
        closeModalCallBack(data);
    });

}

module.exports = function() {
    const $body = $(selectors.body),
        $cart = $('.' + selectors.cart);

    $body.on('click', '.' + selectors.checkoutBtn, (e) => {
        e.preventDefault();

        const $button = $(e.target),
            url = $button.attr('href'),
            validateUrl = $button.data('basketValidate');

        if (!validateUrl) {
            window.location.href = url;
        }

        let options = {
            url: validateUrl,
            type: 'GET',
            dataType: 'json',
            success: function(data) {
                if (data && data.valid && !data.valid.error) {
                    window.location.href = url;
                } else {
                    openModalDialog(data);
                    showProductLevelErrorMessage(data);
                }
            },
            error: function(err) {
                if (err.responseJSON.redirectUrl) {
                    window.window.location.href = err.responseJSON.redirectUrl;
                } else {
                    $body.trigger('basket:notify', err.responseJSON.errorMessage);
                    $cart.spinner().stop();
                }
            }
        };

        $.ajax(options);

    });
};
